import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';

import { DownloadIcon } from '../../../icons';


import GroupedSelect from '../../../components/DemoTabs/GroupedSelect';
import SingalUserImageSelect from '../../../components/DemoTabs/SingalUserImageSelect';
import SettingsIcon from '@mui/icons-material/Settings';
import SingleDatePicker from '../../../components/Date-range-picker/SingleDatePicker';
import TableDownloadBtn from '../../../components/dropdown-select/TableDownloadBtn';
import TimeZoneDropdown from '../../../components/dropdown-select/TimezoneDropdown';


import DownloadScreenshots from '../../../components/Projects/DownloadScreenshots';

import AppDataCard from './AppDataCard';
import UrlsTable from '../activity-table/UrlsTable';
import AllNotes from '../../../components/Projects/AllNotes';
import { Link } from 'react-router-dom';

const UrlActivity = () => {

    const STORAGE_KEY = 'selectedTab';
    const [tabIndex, setTabIndex] = useState(() => {
        const savedTab = localStorage.getItem(STORAGE_KEY);
        return savedTab !== null ? parseInt(savedTab, 10) : 0;
    });

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
        localStorage.setItem(STORAGE_KEY, newValue);
    };

    const [selectedProjects, setSelectedProjects] = useState([]);
    const projects = ['John Doe John Doe John Doe', 'Alice Johnson', 'Rahul Sharma', 'Deepa Nair'];


    const userList = [
        { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Alice Smith', image: null },
        { name: 'Michael Johnson', image: '' },
    ];

    const [selectedUser, setSelectedUser] = useState('');

    const [openAllNotes, setOpenAllNotes] = useState(false);
        const [openDownloadScreenshots, setOpenDownloadScreenshots] = useState(false);
    
    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, marginBottom: '20px', }}>
                <Typography className="fw-semibold mb-0" sx={{ fontSize: '24px', color: '#1A1F36', fontFamily:'Manrope' }}>URL activity</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 1 }}>
               <Link to = '/feature'>
                    <Button sx={{ background: '#fff', borderRadius: '50px', color: '#1A1F36', fontSize: '16px', textTransform: 'capitalize', width: '40px', height: '40px', border: '1px solid #E5E8EB', }}><SettingsIcon /></Button>
               </Link>
                </Box>
            </Box>
            <Box sx={{ width: '100%' }}>
                <Box className="d-flex justify-content-between flex-wrap ">
                    <Box className="d-flex gap-10" sx={{marginBottom: '10px'}}>
                        <GroupedSelect
                            label="Select Project"
                            options={projects}
                            selectedValues={selectedProjects}
                            onChange={setSelectedProjects}
                        />
                        <SingalUserImageSelect
                            label="Select User"
                            options={userList}
                            selectedValue={selectedUser}
                            onChange={setSelectedUser}
                        />
                        <TimeZoneDropdown />

                    </Box>

                    <Box className="d-flex gap-10 align-items-center flex-wrap justify-content-end" sx={{marginBottom: '10px'}}>
                        {/* <TableDownloadBtn /> */}

                        <Button onClick={() => setOpenDownloadScreenshots(true)}
                                            sx={{
                                                background: '#fff',
                                                borderRadius: '50px',
                                                color: '#1A1F36',
                                                fontSize: '16px',
                                                textTransform: 'capitalize',
                                                width: '40px',
                                                height: '38px',
                                                border: '1px solid #E5E8EB',
                                                '&:hover': {
                                                    background: '#f5f5f5'
                                                }
                                            }}
>
                                            <DownloadIcon />
                                        </Button>
                <DownloadScreenshots open={openDownloadScreenshots} onClose={() => setOpenDownloadScreenshots(false)} />

                        <div><Button variant="contained" sx={{ backgroundColor: '#FFFFFF', color: '#0084FF', fontSize: '14px', fontWeight: '600', height: '38px', borderRadius: '100px', border: 'none', boxShadow: 'unset', whiteSpace: 'nowrap', fontFamily:'Manrope' }} onClick={() => setOpenAllNotes(true)}>
                            View Notes
                        </Button>
                            <AllNotes open={openAllNotes} onClose={() => setOpenAllNotes(false)} />
                        </div>
                        <SingleDatePicker />
                    </Box>
                </Box>
            </Box>
            <Box sx={{ margin: '18px auto 32px' }}>
                <AppDataCard />
            </Box>

            
            <Box>
                <UrlsTable />
                <UrlsTable />
                <UrlsTable />
            </Box>

<div style={{padding:'40px', textAlign:'center', backgroundColor:'#fff', border:'1px solid #DFDFDF', borderRadius:'8px'}}>
                <img src='./assets/images/app-activity/no-data-table.png' className='img-fluid' alt='no data table' />
                <Typography sx={{fontSize:'32px', color:'#1A1F36', fontWeight:'600', margin:'48px auto 12px', fontFamily:'Manrope'}}>No Data for This Date Range</Typography>
                <Typography sx={{fontSize:'16px', color:'#373737', fontWeight:'400', fontFamily:'Manrope'}}>Try adjusting the filters or selecting a different date range to view available data.</Typography>
            </div>
        </div>
    )
}

export default UrlActivity
